import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel'
import { Box, Tab, Button, Tooltip } from '@mui/material';
import { useState } from 'react';
import EmployeeRegularizationApproval from './EmployeeRegularizationApproval';
import { useSelector } from 'react-redux';

const AttendanceRegularizationLandingPage = () => {
    const [value, setValue] = useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
    const ExternalUserCoreHr = atsModuleData?.some((item) => item.module_name === "External User CoreHr");
      // raise employee regularization 
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMode, setDialogMode] = useState("add");
    const openRegularizationDialog = (mode, row = null) => {
        setDialogMode(mode);
        setDialogOpen(true);
    }; 
    return (
        <Box sx={{ width: '100%' }}>
            <TabContext value={value}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, flexWrap: 'wrap' }}>
                    <TabList 
                        sx={{
                            minHeight: "40px", ".MuiTab-root": { minHeight: "20px" },
                            '& .MuiTabs-indicator': {
                                width: '100%',
                                display: 'flex',
                                justifyContent: "center !important",
                            },
                            }} 
                            onChange={handleChange} 
                            aria-label="lab API tabs example"
                            variant="scrollable"
                            orientation="horizontal"
                            allowScrollButtonsMobile={true}
                        >
                        <Tab label="Action Required" value="1" />
                        <Tab label="Action Completed" value="2" />
                    </TabList>
                    <Tooltip title={ExternalUserCoreHr ? "Action is disabled." : ""}>
                        <span>
                        <Button
                            sx={{
                            fontWeight: 700,
                            borderRadius: "8px",
                            fontSize: "13px",
                            height: "36px",
                            padding: "2px 10px",
                            boxShadow: "none",
                            marginRight: "10px",
                            }}
                            size="small"
                            variant="contained"
                            className="mpl-primary-btn"
                            onClick={() => openRegularizationDialog("add")}
                            disabled={ExternalUserCoreHr}
                        >
                            Raise Regularization
                        </Button>
                        </span>
                    </Tooltip>
                </Box>                            
                <TabPanel value="1" sx={{ padding: "0px" }}>
                    <EmployeeRegularizationApproval value={"1"} openRegularizationDialog={openRegularizationDialog} dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} dialogMode={dialogMode} />
                </TabPanel>
                <TabPanel value="2" sx={{ padding: "0px" }}>
                    <EmployeeRegularizationApproval value={"2"} openRegularizationDialog={openRegularizationDialog} dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} dialogMode={dialogMode} />
                </TabPanel>
                
            </TabContext>
        </Box>
    )
}

export default AttendanceRegularizationLandingPage;